import React, { useContext, useEffect, useState } from 'react';
import Line from './Line';
import styles from './ProductInfoPage.scss';
import basicStyles from '../style/style.scss';
import { ProductNotFound } from './ProductNotFound';
import { KioskConfigContext } from '../Context/KioskConfigContext';

/* Images */
import bgImage from '../images/product_bg.png';
import butelkaIcon from '../images/icons/butelkaicon.png';
import czasIcon from '../images/icons/czas.png';
import temperaturaIcon from '../images/icons/temperatura.png';
import wybraneDlaCbIcon from '../images/icons/wybrane_dla_cb.png';
import okazjaFotel from '../images/Okazja/fotel.svg';
import okazjaKieliszki from '../images/Okazja/kieliszki.svg';
import okazjaPrezent from '../images/Okazja/prezent.svg';
import emptyBottle from '../images/empty_bottle.png';
import showWinePosBtnImg from '../images/ikonka_lokalizacja_win.png';
import WineLocModal from './WineLocModal/WineLocModal';
import Loading from './Loading';
import { useLocation, useNavigate } from 'react-router-dom';

function Icon({ src }: { src: string }) {
  return <img src={src} alt="icon" />;
}

const occasionList = {
  'do relaksu': okazjaFotel,
  'na prezent': okazjaPrezent,
  'z przyjaciółmi': okazjaKieliszki,
  musujące: okazjaKieliszki,
};

interface Product2Info {
  bottle_image: string;
  pricebar_slot_id: number;

  ean_code: string;
  name: string;
  price: string;
  price_per_litr: string;

  is_new_badge: boolean;
  is_no_alcohol_badge: boolean;

  taste: 'PW' | 'W' | 'PS' | 'S';
  taste2: string;

  color: string;
  country: string;
  foodparing: string;
  flavor: string;
  occasion: 'do relaksu' | 'na prezent' | 'z przyjaciółmi' | 'musujące';

  desc: string;

  temp: string;
  cooling_time: string;
}

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function ProductInfoPage({
  ean_code,
  wybraneDlaCb,
  showPollButton,
  eventName,
  galleryFix,
}: {
  ean_code: string;
  wybraneDlaCb?: boolean;
  showPollButton?: boolean;
  eventName: 'scan' | 'poll_gallery';
  galleryFix?: boolean;
}) {
  const [product, setProduct] = useState<Product2Info | null>(null);
  const [showNotFound, setShowNotFound] = useState<boolean>(false);
  const [showWineLocModal, setShowWineLocModal] = useState<boolean>(false);
  const query = useQuery();
  const showWineBtn = query.get('hide_wine_location') == null;
  const showPrice = query.get('hide_price') == null;

  useEffect(() => {
    const url = `/api/v1/products2/${ean_code}/?event=${eventName}`;
    fetch(url)
      .then((r) => {
        if (!r.ok) {
          throw new Error('NotFound');
        }
        return r.json();
      })
      .then((data) => {
        setProduct(data);
        setShowNotFound(false);
      })
      .catch((error) => {
        console.error(error);
        setShowNotFound(true);
      });
  }, [ean_code]);

  const lineWidth = '400px';

  let occasionSvg = okazjaKieliszki;
  if (product) {
    occasionSvg = occasionList[product.occasion];
  }

  if (showNotFound) {
    return (
      <div className={styles.container}>
        <ProductNotFound />
      </div>
    );
  }
  if (product == null) {
    return (
      <div>
        <Loading />
      </div>
    );
  }
  return (
    <div className={styles.container} style={{ backgroundImage: `url(${bgImage})` }}>
      <div className={styles.bottleRow}>
        {/*
        // NIE DZIAŁA, dodaje scrolla do całego okna
        {wybraneDlaCb && (
          <div style={{ height: '100%', position: 'absolute', width: '33%' }}>
            <img className={styles.wybraneDlaCb} src={wybraneDlaCbIcon} alt="wybranedlacb" />
          </div>
        )}
        */}
        <img className={styles.butelkaImg} src={product.bottle_image ? product.bottle_image : emptyBottle} alt="" />
      </div>
      <div className={styles.contentRow}>
        <div className={styles.title}>
          <h2> </h2>
          <h1>{product.name}</h1>
        </div>
        {showWineBtn && (
          <div style={{ position: 'absolute', top: '4%', right: '1%' }} onClick={() => setShowWineLocModal(true)}>
            <img src={showWinePosBtnImg} alt="showWinePosBtnImg" style={{ height: '145px' }} />
          </div>
        )}
        <Line width={lineWidth} />
        <br />
        <div className={styles.detailRow}>
          <div className={styles.desc}>{product?.desc}</div>
          <div className={styles.badges}>
            <div>
              Kraj pochodzenia: <span style={{ fontWeight: '200' }}>{product?.country}</span>
            </div>
            {/* <div>
              <Icon src={producentIcon} /> Misket, Dimyat
            </div> */}
            <br />
            <div>
              <Icon src={temperaturaIcon} /> {product?.temp}
            </div>
            <div>
              <Icon src={czasIcon} /> czas chłodzenia {product?.cooling_time}
            </div>
            <div>
              <Icon src={butelkaIcon} /> 0.75
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <div className={styles.spacer}>
            <Line width={lineWidth} />
          </div>
          <div className={styles.footerIcons}>
            <div className={styles.row} style={{ textAlign: 'left' }}>
              <div className={styles.wineOccasion}>
                <img src={occasionSvg} className={styles.wineOccasionImg} alt={product?.occasion} />
                <div className={styles.wineOccasionName}>{product?.occasion}</div>
              </div>
            </div>
            <div className={styles.row} style={{ textAlign: 'center' }}>
              <div className={styles.wineColorTaste}>{product?.color}</div>
              <Line color="#000" width="185px" thic="4px" margin="4px" />
              <div className={styles.wineColorTaste}>{product?.taste2}</div>
              <div className={styles.wineFlavor}>{product?.flavor}</div>
            </div>
            <div className={styles.row} style={{ textAlign: 'right' }}>
              {showPrice && (
                <div className={styles.priceWrapper}>
                  <div className={styles.price}>{product?.price}</div>
                  <div className={styles.underPrice}>*cena sugerowana</div>
                </div>                
              )}
            </div>
          </div>
        </div>
      </div>
      <WineLocModal
        slotId={product.pricebar_slot_id}
        show={showWineLocModal}
        setShow={setShowWineLocModal}
        galleryFix={galleryFix}
      />
    </div>
  );
}
